import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-017d0bfd")

_pushScopeId("data-v-017d0bfd")
const _hoisted_1 = {
  key: 0,
  style: {"width":"100%","height":"30px"}
}
const _hoisted_2 = {
  key: 1,
  class: "top-button-group flex alginC"
}
const _hoisted_3 = { class: "mar-t-12" }
const _hoisted_4 = { class: "mar-t-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "合作方", -1)
const _hoisted_6 = { class: "mar-t-12" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "服务类型", -1)
const _hoisted_8 = { class: "mar-t-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "保险公司", -1)
const _hoisted_10 = { class: "mar-t-12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "单位", -1)
const _hoisted_12 = { class: "mar-t-12" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "接车人", -1)
const _hoisted_14 = { class: "mar-t-12" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "车型", -1)
const _hoisted_16 = { class: "mar-t-12 mar-l-16" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_18 = { class: "flex flexC" }
const _hoisted_19 = {
  key: 0,
  class: "view-cirle"
}
const _hoisted_20 = { class: "flex flexC alignC" }
const _hoisted_21 = {
  id: "printBtn",
  style: {"display":"none"}
}
const _hoisted_22 = { class: "flex flexR mar-t-22" }
const _hoisted_23 = { style: {"width":"430px","margin":"0 auto"} }
const _hoisted_24 = { class: "padding-tb-20 flex flexC alignC bg-f4" }
const _hoisted_25 = { class: "mar-l-16" }
const _hoisted_26 = { class: "mar-l-16" }
const _hoisted_27 = { class: "flex flexSb mar-t-30" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", null, "报价金额", -1)
const _hoisted_29 = {
  key: 0,
  class: "flex flexSb mar-t-30 alignC"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 直接减免 ")
const _hoisted_31 = {
  key: 1,
  class: "flex flexSb mar-t-30"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", null, "工单预收抵扣", -1)
const _hoisted_33 = {
  key: 2,
  class: "flex flexSb mar-t-30"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("div", null, "工单预收退款：(将自动生成预收退款应付)", -1)
const _hoisted_35 = {
  key: 3,
  class: "flex flexSb mar-t-30"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", null, "工单预收退款：(将自动生成预收退款应付)", -1)
const _hoisted_37 = {
  key: 4,
  class: "flex flexSb mar-t-30 alignC"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("余额抵扣 ")
const _hoisted_39 = {
  key: 5,
  class: "flex flexSb mar-t-30"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("div", null, "会员剩余门店余额", -1)
const _hoisted_41 = {
  key: 6,
  class: "flex flexSb mar-t-30"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("div", null, "结算金额", -1)
const _hoisted_43 = { class: "c-red" }
const _hoisted_44 = {
  key: 7,
  class: "flex flexSb mar-t-30"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", null, "应收金额", -1)
const _hoisted_46 = { class: "c-red" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode("挂帐")
const _hoisted_49 = { class: "mar-l-12 c-99" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "c-ff" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "取 消", -1)
const _hoisted_53 = { style: {"width":"430px","margin":"0 auto"} }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_55 = { class: "dialog-footer" }
const _hoisted_56 = { class: "c-ff" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", null, "取 消", -1)
const _hoisted_58 = { class: "flex flexR" }
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "打印报价单", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "工单预收款", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "车辆信息", -1)
const _hoisted_62 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_63 = { class: "text-center f-14 bold" }
const _hoisted_64 = {
  style: {"margin":"0 auto","padding":"30px 0","width":"600px"},
  class: "mar-t-12"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_66 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_67 = { class: "cost" }
const _hoisted_68 = { class: "flex flexC alignC mar-b-20 relative" }
const _hoisted_69 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增其他成本", -1)
const _hoisted_70 = { class: "c-30 f-20" }
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "c-ff f-12" }, "删除", -1)
const _hoisted_72 = { class: "flex flexC add-cost-form" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 自动生成采购应付款 ")
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "取 消", -1)
const _hoisted_77 = { class: "print" }
const _hoisted_78 = { class: "header" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_80 = { class: "store_name" }
const _hoisted_81 = {
  key: 0,
  class: "store"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 扫码关注公众号 ", -1)
const _hoisted_83 = { class: "qrcode" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "title flex-1" }, " 车辆维修工时配件结算单 ", -1)
const _hoisted_85 = { class: "body" }
const _hoisted_86 = { class: "order-head flex alignC" }
const _hoisted_87 = { class: "ordersn flex-1" }
const _hoisted_88 = { class: "time" }
const _hoisted_89 = { class: "order-info" }
const _hoisted_90 = /*#__PURE__*/_createVNode("th", null, "车牌号码：", -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("th", null, "车型：", -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("th", null, "车架号：", -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("th", null, "送修人；", -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("th", null, "联系电话：", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("th", null, "服务类型：", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("th", null, "进厂时间：", -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("th", null, "进厂里程：", -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("th", null, "接车人：", -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("th", null, "出厂时间：", -1)
const _hoisted_100 = /*#__PURE__*/_createVNode("th", null, "下次保养：", -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("th", null, "下次保养里程：", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("th", null, "送修单位：", -1)
const _hoisted_103 = {
  key: 0,
  class: "project-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_104 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "维修项目"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_106 = {
  colspan: "4",
  class: "count"
}
const _hoisted_107 = {
  key: 1,
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_108 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "配件名称"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_109 = {
  colspan: "5",
  class: "count"
}
const _hoisted_110 = {
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "报价金额"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "优惠券"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "余额抵扣"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "其他优惠"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "合计优惠"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "结算金额")
  ])
], -1)
const _hoisted_112 = { key: 0 }
const _hoisted_113 = {
  colspan: "6",
  class: "total"
}
const _hoisted_114 = { class: "other" }
const _hoisted_115 = { class: "info" }
const _hoisted_116 = { class: "item" }
const _hoisted_117 = { class: "item" }
const _hoisted_118 = { class: "item" }
const _hoisted_119 = {
  key: 0,
  class: "store"
}
const _hoisted_120 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 微信扫码支付 ", -1)
const _hoisted_121 = { class: "qrcode" }
const _hoisted_122 = { class: "footer" }
const _hoisted_123 = { class: "address" }
const _hoisted_124 = { class: "telphone" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_PrintForm = _resolveComponent("PrintForm")
  const _directive_loading = _resolveDirective("loading")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "bg-ff table-content",
      style: _ctx.isPrint?'padding-bottom: 180px;':''
    }, [
      (!_ctx.selectList)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, "加载中", 512)), [
            [_directive_loading]
          ])
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_el_select, {
                class: "width-114",
                modelValue: _ctx.screenParameter.date_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date_type = $event)),
                clearable: "",
                placeholder: "请选择"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "开单时间",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "结算时间",
                    value: "2"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_date_picker, {
                class: "mar-l-8",
                disabled: !_ctx.screenParameter.date_type,
                type: "daterange",
                modelValue: _ctx.screenParameter.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.date = $event)),
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束时间",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenChange($event, 'date')))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.partner_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.partner_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.partner_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.basicset_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.basicset_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                placeholder: "请选择",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.project_type_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      value: item.basicset_id,
                      label: item.basicset_name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.cicompany_id,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.cicompany_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.insurance_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.units_id,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.screenParameter.units_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                placeholder: "请选择",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.unitList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.repair_unit_id,
                      label: item.repair_unit_name,
                      value: item.repair_unit_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.meet_vehicle_id,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.screenParameter.meet_vehicle_id = $event)),
                class: "width-100 mar-l-8",
                clearable: "",
                placeholder: "请选择",
                filterable: "",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staffList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.nickname,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_select, {
                class: "width-100 mar-l-8",
                modelValue: _ctx.screenParameter.car_brand_id,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.screenParameter.car_brand_id = $event)),
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.screenChange($event, 'select_brand')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.carbrandList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.brand_name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                class: "width-114 mar-l-8",
                modelValue: _ctx.screenParameter.car_series_id,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.screenParameter.car_series_id = $event)),
                disabled: !_ctx.screenParameter.car_brand_id,
                clearable: "",
                placeholder: "请选择",
                filterable: "",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.carseriesList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.series_name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_el_input, {
                style: {"width":"230px"},
                modelValue: _ctx.screenParameter.search,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.screenParameter.search = $event)),
                placeholder: "单据编号/车牌/送修人/手机号",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.screenChange($event, 'search'))),
                "suffix-icon": "el-icon-search"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                class: "mar-l-9 bg-red",
                onClick: _ctx.exportChange
              }, {
                default: _withId(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "单据编号",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", {
                  class: "c-red ordersn",
                  onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row.order_id))
                }, _toDisplayString(scope.row.ordersn), 9, ["onClick"]),
                (scope.row.is_pre==1)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, " 预 "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_20, [
                (_ctx.roleList.settlement && scope.row.button_list.settlement == 1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx._settlement(scope.row.order_id)),
                      class: "btn-red-line"
                    }, "结算 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.resettlement && scope.row.button_list.resettlement == 1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.resettlement(scope.row.order_id)),
                      class: "btn-red-line mar-l-2"
                    }, "反结算 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.other_cost)
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      onClick: ($event: any) => (_ctx.otherCostClick(scope.row)),
                      class: "btn-red-line mar-l-2"
                    }, "其他成本 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.roleList.confirm_settlement && scope.row.button_list.confirm_settlement == 1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 3,
                      onClick: ($event: any) => (_ctx._confirmSettlement(scope.row.order_id)),
                      class: "btn-red-line mar-l-2"
                    }, "结算确认 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.button_list.printing == 1)
                  ? (_openBlock(), _createBlock("div", {
                      key: 4,
                      onClick: ($event: any) => (_ctx.bindPrint(scope.row.order_id)),
                      class: "btn-red mar-l-2"
                    }, "打印 ", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", _hoisted_21, null, 512), [
                  [_directive_print, _ctx.printData]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode(_component_el_pagination, {
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.currentPage,
          "page-sizes": [10, 20,50,100],
          "page-size": _ctx.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
      ]),
      _createVNode(_component_el_dialog, {
        title: _ctx.dialog_title,
        modelValue: _ctx.dialog_show,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialog_show = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", null, "车牌号码：" + _toDisplayString(_ctx.form.order_crd_code_text), 1),
              _createVNode("div", _hoisted_25, "会员号：" + _toDisplayString(_ctx.form.user_id), 1),
              _createVNode("div", _hoisted_26, "会员门店余额：" + _toDisplayString(_ctx.form.user_store_balance), 1)
            ]),
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.order_offer_price), 1)
            ]),
            (_ctx.userInfo.store_id!=4)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  _createVNode("div", null, [
                    _hoisted_30,
                    (_ctx.dialog_title != '结算')
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          class: "width-82 mar-l-2",
                          type: "number",
                          modelValue: _ctx.form.discount_price,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.discount_price = $event)),
                          max: _ctx.form.order_offer_price,
                          min: "0",
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.reductionChange($event))),
                          onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.reductionChange($event)))
                        }, null, 8, ["modelValue", "max"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.discount_price), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.order_advance_payment_text>0)
              ? (_openBlock(), _createBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.order_advance_payment_text), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.refund_price>0 && _ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.refund_price), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title == '结算' && _ctx.form.is_advance==1)
              ? (_openBlock(), _createBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.advance_price), 1)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.form.order_offer_price - _ctx.form.discount_price-_ctx.form.order_advance_payment_text) > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  _createVNode("div", null, [
                    _hoisted_38,
                    (_ctx.form.user_store_balance > 0 && _ctx.dialog_title != '结算')
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          class: "width-82 mar-l-2",
                          type: "number",
                          modelValue: _ctx.form.use_balance,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.use_balance = $event)),
                          max: _ctx.form.user_store_balance,
                          min: "0",
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.balanceChange($event))),
                          onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.balanceChange($event)))
                        }, null, 8, ["modelValue", "max"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.use_balance), 1)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.form.order_offer_price - _ctx.form.discount_price-_ctx.form.order_advance_payment_text) > 0 && _ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.user_store_balance-_ctx.form.use_balance), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode("div", _hoisted_43, "¥" + _toDisplayString(_ctx.form.price), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title == '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("div", _hoisted_46, "¥" + _toDisplayString(_ctx.form.price), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form, {
              class: "mar-t-20",
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.form_rules
            }, {
              default: _withId(() => [
                (_ctx.dialog_title == '结算')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "收款方式",
                      required: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "settlement_type" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  placeholder: "请选择",
                                  clearable: "",
                                  modelValue: _ctx.form.settlement_type,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.settlement_type = $event)),
                                  disabled: _ctx.form.is_hang_,
                                  style: {"width":"142px"}
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.collection, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "price" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  class: "mar-l-8 mar-r-8",
                                  style: {"width":"101px"},
                                  min: "0",
                                  modelValue: _ctx.form.payment_price,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.payment_price = $event)),
                                  disabled: _ctx.form.is_hang_
                                }, null, 8, ["modelValue", "disabled"]),
                                _hoisted_47,
                                _createVNode(_component_el_checkbox, {
                                  class: "mar-l-24",
                                  modelValue: _ctx.form.is_hang_,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.is_hang_ = $event))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_48
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "工单备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.settlement_notes,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.settlement_notes = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "备注给内部员工看"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "打印备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.printing_desc,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.printing_desc = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "请输入内容"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.dialog_title != '结算')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "结算类别"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.settleData.settlement_class,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.settleData.settlement_class = $event)),
                          class: "width-100",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementType, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.type_name,
                                value: item.type_id,
                                key: item.type_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_49, _toDisplayString(_ctx.settlementType[_ctx.settleData.settlement_class].type_desc), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode("div", _hoisted_50, [
              _createVNode(_component_el_button, {
                class: "bg-red",
                onClick: _ctx._submitForm
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_51, _toDisplayString(_ctx.dialog_title == '结算' ? '结算' : '确认'), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.dialog_show = false))
              }, {
                default: _withId(() => [
                  _hoisted_52
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_directive_loading, _ctx.form_load]
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_el_dialog, {
        title: _ctx.settle_title,
        modelValue: _ctx.settle_show,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.settle_show = $event)),
        center: "",
        width: 600
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_55, [
            _createVNode(_component_el_button, {
              class: "bg-red",
              onClick: _ctx._submitSettle
            }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_56, _toDisplayString(_ctx.settle_title == '结算' ? '结算' : '确认'), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.settle_show = false))
            }, {
              default: _withId(() => [
                _hoisted_57
              ]),
              _: 1
            })
          ])
        ]),
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_53, [
            _createVNode(_component_el_form, {
              class: "mar-t-20",
              ref: "return_price_ref",
              model: _ctx.return_price_form_data,
              rules: _ctx.return_price_rules
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "收款方式",
                  required: ""
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { prop: "settlement_type" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              placeholder: "请选择",
                              clearable: "",
                              modelValue: _ctx.return_price_form_data.settlement_type,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.return_price_form_data.settlement_type = $event)),
                              style: {"width":"142px"}
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.collection, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { prop: "price" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "mar-l-8 mar-r-8",
                              style: {"width":"101px"},
                              modelValue: _ctx.return_price_form_data.price,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.return_price_form_data.price = $event))
                            }, null, 8, ["modelValue"]),
                            _hoisted_54
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "回款备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.return_price_form_data.return_price_notes,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.return_price_form_data.return_price_notes = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "请输入内容"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ], 512), [
            [_directive_loading, _ctx.form_load]
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "工单详情",
        modelValue: _ctx.dialogFormVisible,
        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.dialogFormVisible = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_58, [
            _createVNode(_component_el_button, {
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.bindPrint(_ctx.currentOrder)))
            }, {
              default: _withId(() => [
                _hoisted_59
              ]),
              _: 1
            }),
            (_ctx.orderDetail.orderstatus!=5 && _ctx.orderDetail.orderstatus!=-1 && _ctx.roleList.advance)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _ctx.preparePayClick
                }, {
                  default: _withId(() => [
                    _hoisted_60
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, { onClick: _ctx.getCarInfo }, {
              default: _withId(() => [
                _hoisted_61
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("table", _hoisted_62, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ]),
          (_ctx.orderDetail.order_offer_project.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: _ctx.orderDetail.order_offer_project,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 1),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.order_offer_mountings.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: _ctx.orderDetail.order_offer_mountings,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 2),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.mountings_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 2,
                data: _ctx.orderDetail.mountings_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 3),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    "min-width": "80"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("div", null, _toDisplayString(scope.$index+1), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.else_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 3,
                data: _ctx.orderDetail.else_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 4),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.settlement.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 4,
                data: _ctx.orderDetail.settlement,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "header-cell-style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.preparePayDia_show,
        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.preparePayDia_show = $event)),
        center: "",
        width: "465"
      }, {
        default: _withId(() => [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_63, "车牌号码：" + _toDisplayString(_ctx.orderDetail.car_code), 1),
            _createVNode("div", _hoisted_64, [
              _createVNode(_component_el_form, {
                ref: "preparePayFormRef",
                model: _ctx.preparePayForm,
                rules: _ctx.prepareFormRules,
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "预收日期" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.preparePayForm.time,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.preparePayForm.time = $event)),
                        "value-format": "x",
                        readonly: "true"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "收款方式",
                    prop: ""
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.preparePayForm.payTypeOne,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.preparePayForm.payTypeOne = $event)),
                        placeholder: "请选择",
                        clearable: "",
                        class: "mar-r-8",
                        style: {"width":"154px"}
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payTypeArray.zf, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.basicset_name,
                              value: item.basicset_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        placeholder: "输入金额",
                        modelValue: _ctx.preparePayForm.priceOne,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.preparePayForm.priceOne = $event)),
                        class: "width-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "收款方式" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.preparePayForm.payTypeTwo,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.preparePayForm.payTypeTwo = $event)),
                        placeholder: "请选择",
                        clearable: "",
                        class: "mar-r-8",
                        style: {"width":"154px"}
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payTypeArray.zf, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.basicset_name,
                              value: item.basicset_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        placeholder: "输入金额",
                        modelValue: _ctx.preparePayForm.priceTwo,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.preparePayForm.priceTwo = $event)),
                        class: "width-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "预收款备注" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        placeholder: "请输入内容",
                        clearable: "",
                        rows: "2",
                        modelValue: _ctx.preparePayForm.desc,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.preparePayForm.desc = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        class: "bg-red",
                        onClick: _ctx.savePreparePay
                      }, {
                        default: _withId(() => [
                          _hoisted_65
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _withDirectives(_createVNode(_component_el_table, {
              data: _ctx.prepareData.prepareList,
              stripe: "",
              style: {"width":"100%"},
              class: "table",
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  label: "预收日期",
                  align: "center",
                  "min-width": "80",
                  prop: "pay_time_text"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  align: "center",
                  "min-width": "80",
                  prop: "payment_price"
                }),
                _createVNode(_component_el_table_column, {
                  label: "收款方式",
                  align: "center",
                  "min-width": "80",
                  prop: "basicset_name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  align: "center",
                  "min-width": "80",
                  prop: "payment_remarks"
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]), [
              [_directive_loading, _ctx.prepareData.prepareLoading]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "车辆信息",
        modelValue: _ctx.carInfoDia_show,
        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.carInfoDia_show = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("table", _hoisted_66, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carInfoTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        title: "新增其他成本",
        modelValue: _ctx.otherCostData.costDialogVisible,
        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.otherCostData.costDialogVisible = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _createVNode(_component_el_button, {
                class: "bg-red mar-r-8 add-cost absolute",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.otherCostData.isAddCost = true))
              }, {
                default: _withId(() => [
                  _hoisted_69
                ]),
                _: 1
              }),
              _createVNode("p", _hoisted_70, "车牌号码：" + _toDisplayString(_ctx.otherCostData.costDialogCarCode), 1)
            ]),
            _withDirectives(_createVNode(_component_el_table, {
              data: _ctx.otherCostData.costTableData,
              stripe: "",
              style: {"width":"100%"},
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostListColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128)),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  align: "center",
                  "min-width": "80"
                }, {
                  default: _withId((scope) => [
                    _createVNode(_component_el_button, {
                      class: "bg-red",
                      onClick: ($event: any) => (_ctx.deleteElseCost(scope.row.othercosts_id))
                    }, {
                      default: _withId(() => [
                        _hoisted_71
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]), [
              [_directive_loading, _ctx.otherCostData.costLoading]
            ])
          ], 512), [
            [_vShow, !_ctx.otherCostData.isAddCost]
          ]),
          _withDirectives(_createVNode("div", _hoisted_72, [
            _createVNode(_component_el_form, {
              ref: "addCostFormRef",
              "label-width": "150px",
              model: _ctx.otherCostData.addCostForm,
              rules: _ctx.costRules
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "成本项目",
                  prop: "othercosts_name"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      class: "add-cost-input",
                      modelValue: _ctx.otherCostData.addCostForm.othercosts_name,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.otherCostData.addCostForm.othercosts_name = $event)),
                      placeholder: "请输入成本项目"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "成本",
                  prop: "othercosts_costprice"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      class: "add-cost-input",
                      modelValue: _ctx.otherCostData.addCostForm.othercosts_costprice,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.otherCostData.addCostForm.othercosts_costprice = $event)),
                      placeholder: "请输入成本"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "成本承担部门",
                  prop: "branch_id"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      modelValue: _ctx.otherCostData.addCostForm.branch_id,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.otherCostData.addCostForm.branch_id = $event)),
                      placeholder: "请选择成本承担部门"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.branch_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.name,
                            value: item.id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "供应商",
                  prop: "supplier_id"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      filterable: "",
                      modelValue: _ctx.otherCostData.addCostForm.supplier_id,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.otherCostData.addCostForm.supplier_id = $event)),
                      placeholder: "请选择供应商"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.supplier_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.supplier_name,
                            value: item.supplier_id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "采购员" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      class: "add-cost-input",
                      modelValue: _ctx.otherCostData.addCostForm.admin_id,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.otherCostData.addCostForm.admin_id = $event)),
                      placeholder: "不限制"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.nickname,
                            value: item.id,
                            key: index
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "生成应付款" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      "true-label": 1,
                      "false-label": 0,
                      modelValue: _ctx.otherCostData.addCostForm.cpayment,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.otherCostData.addCostForm.cpayment = $event))
                    }, {
                      default: _withId(() => [
                        _hoisted_73
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_74, [
                      _createVNode(_component_el_button, {
                        class: "bg-red mar-r-8",
                        onClick: _ctx.addElseCost
                      }, {
                        default: _withId(() => [
                          _hoisted_75
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.otherCostData.isAddCost = false))
                      }, {
                        default: _withId(() => [
                          _hoisted_76
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ], 512), [
            [_vShow, _ctx.otherCostData.isAddCost]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    _withDirectives(_createVNode(_component_PrintForm, { id: "print" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_77, [
          _createVNode("div", _hoisted_78, [
            _hoisted_79,
            _createVNode("div", _hoisted_80, _toDisplayString(_ctx.userInfo.store_name), 1),
            (_ctx.publicImgeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_81, [
                  _hoisted_82,
                  _createVNode("div", _hoisted_83, [
                    _createVNode("img", {
                      src: _ctx.publicImgeUrl,
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_84
          ]),
          _createVNode("div", _hoisted_85, [
            _createVNode("div", _hoisted_86, [
              _createVNode("div", _hoisted_87, " 单据编号：" + _toDisplayString(_ctx.orderDetail.ordersn), 1),
              _createVNode("div", _hoisted_88, _toDisplayString(_ctx.orderDetail.settlement_time_text), 1)
            ]),
            _createVNode("table", _hoisted_89, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_90,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.car_code), 1),
                  _hoisted_91,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.series_name), 1),
                  _hoisted_92,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.vin), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_93,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair), 1),
                  _hoisted_94,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair_phone), 1),
                  _hoisted_95,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.basicset_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_96,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.create_time_text), 1),
                  _hoisted_97,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.mitplant), 1),
                  _hoisted_98,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_99,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.delivery_time_text), 1),
                  _hoisted_100,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.next_maintain), 1),
                  _hoisted_101,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.next_maintain_mileage), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_102,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.units_id_name), 1)
                ])
              ])
            ]),
            (_ctx.isProject)
              ? (_openBlock(), _createBlock("table", _hoisted_103, [
                  _hoisted_104,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_project, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.print_project_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _hoisted_105,
                      _createVNode("th", _hoisted_106, "维修工时费小计：￥" + _toDisplayString(_ctx.orderDetail?.project_sum_quoted_price || 0), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isMountings)
              ? (_openBlock(), _createBlock("table", _hoisted_107, [
                  _hoisted_108,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_mountings, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.mountings_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_109, "配件费用小计：￥" + _toDisplayString(_ctx.orderDetail?.mountings_sum_quoted_price || 0), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("table", _hoisted_110, [
              _hoisted_111,
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.offer_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.coin_voucher || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.other_coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.total_coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.settlement_price || 0), 1)
                ]),
                (_ctx.orderDetail.cash_back_price)
                  ? (_openBlock(), _createBlock("tr", _hoisted_112, [
                      _createVNode("th", _hoisted_113, " 会员号：" + _toDisplayString(_ctx.orderDetail.user_id) + " 本次消费返现：￥" + _toDisplayString(_ctx.orderDetail.cash_back_price), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_114, [
              _createVNode("div", _hoisted_115, [
                _createVNode("div", _hoisted_116, " 客　户：" + _toDisplayString(_ctx.orderDetail.user_name), 1),
                _createVNode("div", _hoisted_117, " 接车员：" + _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1),
                _createVNode("div", _hoisted_118, " 出纳：" + _toDisplayString(_ctx.orderDetail.cashier_name), 1)
              ]),
              (_ctx.qrcodeImgeUrl&&_ctx.orderDetail.orderstatus==4)
                ? (_openBlock(), _createBlock("div", _hoisted_119, [
                    _hoisted_120,
                    _createVNode("div", _hoisted_121, [
                      _createVNode("img", {
                        src: _ctx.qrcodeImgeUrl,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_122, [
              _createVNode("div", _hoisted_123, " 地址：" + _toDisplayString(_ctx.orderDetail.address), 1),
              _createVNode("div", _hoisted_124, " 电话：" + _toDisplayString(_ctx.orderDetail.service_phone), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isPrint]
    ])
  ], 64))
})